import { APP_TICK_INTERVAL, INTERVAL_CYCLE_BIT, } from '@/constants/global';
export default {
    SET_VIEW_STATE_BAROMONEY_WITHDRAW_IN_PROGRESS(state, isInProgress) {
        state.viewState.baromoney.baromoneyWithdraw.isInProgress = isInProgress;
    },
    START_FETCHING(state) {
        state.fetching += 1;
    },
    END_FETCHING(state) {
        state.fetching -= 1;
    },
    SET_PENDING(state, isPending) {
        state.isPending = isPending;
    },
    SET_TABS(state, { activeTabIndex }) {
        state.viewState.tabs.activeTabIndex = activeTabIndex;
    },
    SET_SEARCH_OPENED(state, isSearchOpened) {
        state.viewState.isSearchOpened = isSearchOpened;
    },
    SET_SEARCH_QUERY(state, searchQuery) {
        state.viewState.searchQuery = searchQuery;
    },
    SET_START_APP_TICK(state) {
        setInterval(() => {
            const nextAppTickCount = state.appTickCount + 1;
            state.appTickCount = nextAppTickCount % INTERVAL_CYCLE_BIT;
        }, APP_TICK_INTERVAL);
    },
    SET_SELECTED_NAV_ITEM(state, item) {
        state.viewState.selectedNavItem = item;
    },
    SET_CURRENT_PAGE_NAME(state, name) {
        state.viewState.currentPageName = name;
    },
    SET_PAGE_TITLE(state, pageTitle) {
        state.viewState.pageTitle = pageTitle;
    },
};
